export default {
  getUnderlyingAssetTypes: state => state.underlyingAssetTypes || [],
};
